import 'Guide/entrypoint/guidepage';
import './home_page_hero';
import './partnerships_display';
import './featured_documents';
import 'Shared/Campaigns/campaign-banner-wp';
import { WPNewsletter } from 'Shared/newsletter';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';
import { querySelectorAllWithShadowed } from 'Shared/utils/shadow-wrapper';

onDomReady(() => {
   querySelectorAllWithShadowed('.newsletter-sub').forEach(newsLetterEl => {
      new WPNewsletter(newsLetterEl, 'Homepage');
   });

   querySelectorAllWithShadowed('.js-product-ad').forEach(el => {
      el.addEventListener('click', () => {
         trackAnalyticsCustomEvent({
            eventCategory: 'Featured Products - Homepage',
            eventAction: `Featured on Homepage - ${el.get('data-ga-product')}`,
         });
      });
   });

   querySelectorAllWithShadowed('.js-home-cta').forEach(el => {
      el.addEventListener('click', () => {
         trackAnalyticsCustomEvent({
            eventCategory: 'Home Page',
            eventAction: `Home Page - CTA - ${el.get('data-ga-link-text')}`,
         });
      });
   });

   querySelectorAllWithShadowed('.js-home-guide-category').forEach(el => {
      el.addEventListener('click', () => {
         trackAnalyticsCustomEvent({
            eventCategory: 'Home Page',
            eventAction: 'Home Page - Guide Category - Click',
         });
      });
   });
});
